import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { Button } from '@mui/material'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.secondary.contrastText,
    transition: `background-color ${tokens.transition.fast}, color ${tokens.transition.fast}`,
    '&:hover': {
      backgroundColor: tokens.color.primary[50],
      color: tokens.color.primary[700],
    },
  },
}))

interface Props {
  onClick?: () => void
  size?: 'small' | 'medium' | undefined
  className?: string
  content?: any
  disabled?: boolean
  type?: string
  startIcon?: React.ReactNode
}

export const TransparentButton: React.FC<Props> = ({
  onClick,
  size,
  className,
  content,
  disabled,
  children,
  startIcon,
}) => {
  const classes = useStyles()

  return (
    <Button
      className={classNames(classes.root, className)}
      onClick={onClick}
      startIcon={startIcon}
      size={size}
      disabled={disabled}
    >
      {content}
      {children}
    </Button>
  )
}
